import { Outlet } from 'react-router'

import { useAuth } from '../../lib/auth/AuthContext'

const spinnerStyle = {
  position: 'fixed', inset: 0,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#0a0a0f', color: '#666',
  fontFamily: 'var(--m-font)', fontSize: 12,
}

export function ProtectedRoute() {
  const { me, loading } = useAuth()

  // No-session path: AuthContext has already triggered the portal SSO
  // redirect. Keep the spinner visible while the browser navigates away.
  if (loading || !me) {
    return <div style={spinnerStyle}>Checking session…</div>
  }
  return <Outlet />
}
